module.exports = __webpack_public_path__ + "src/img/addIcon.8f58fca8.svg";